import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { EnvService } from './environment.service';

@Injectable({
  providedIn: 'root'
})
export class LanguageService {

  constructor(private http: HttpClient, public environment: EnvService) {}
  getLanguagues(){
    return this.http.get<any[]>('./assets/i18n/languages.json');
  }
}
